module.exports = __webpack_public_path__ + "static/media/Homepage - Mobile 320x100.7b5d72d5.png";